if (!customElements.get('product-carousel')) {
  const dataLayer = window.dataLayer || [];
  class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector('.swiper-container');
      this.swiperWrapper = this.querySelector('.swiper-wrapper');
      this.initialized = false;
    }

    connectedCallback() {
      if (this.swiperContainer) {
        this.swiperContainer.style.opacity = '0';
        this.swiperContainer.style.transition = 'opacity 0.3s ease';
      }

      requestAnimationFrame(() => this.initSwiper());
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }

    initSwiper() {
      if (!this.swiperContainer || !this.swiperWrapper || this.initialized) {
        return;
      }

      this.initialized = true;

      const noPagination = this.swiperWrapper.classList.contains('no-pagination');
      const pagination = noPagination
        ? false
        : {
            el: '.swiper-pagination',
            clickable: true,
          };

      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 2.2,
        spaceBetween: 16,
        pagination: window.innerWidth < 768 ? false : pagination,
        breakpoints: {
          992: {
            freeMode: false,
            spaceBetween: 24,
            slidesPerView: noPagination ? 3 : 4.1,
            slidesPerGroup: noPagination ? 3 : 4,
          },
        },
        on: {
          init: () => {
            if (this.swiperContainer) {
              this.swiperContainer.style.opacity = '1';
            }
          },
        },
      });

      if (pagination && this.swiperWrapper) {
        this.swiperWrapper.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
          this.pushDataLayerEvent('carousel_dots', index + 1);
        });
      }
    }

    pushDataLayerEvent(action, label) {
      dataLayer.push({
        event: 'homepage_engagements',
        event_category: 'homepage_carousel',
        event_action: action,
        event_label: label,
      });
    }
  }

  customElements.define('product-carousel', ProductCarousel);
}
